const PREFIX = '@@KANDY/'

export const EVENTS_ON = PREFIX + 'EVENTS_ON'
export const EVENTS_OFF = PREFIX + 'EVENTS_OFF'
export const EVENTS_SUBSCRIBE = PREFIX + 'EVENTS_SUBSCRIBE'
export const EVENTS_UNSUBSCRIBE = PREFIX + 'EVENTS_UNSUBSCRIBE'
export const EVENTS_ALIAS = PREFIX + 'EVENTS_ALIAS'
export const EVENTS_EMIT = PREFIX + 'EVENTS_EMIT'
export const MAP_EVENTS = PREFIX + 'MAP_EVENTS'
